import { createAction } from '@reduxjs/toolkit';

import { ContainerFromApi } from '../../models';

export const containersOnSendingRequest = createAction('containers/onSendingRequest');
export const containersOnReceived = createAction<ContainerFromApi[]>('containers/onReceived');
export const containersOnFailed = createAction<unknown>('containers/onFailed');
export const containersOnCurrentSwitched = createAction<string>('containers/onCurrentSwitched');
